module.exports = __webpack_public_path__ + "static/media/queen_diamond.1132b9fe.png";